import { IJoystickUpdateEvent } from "react-joystick-component/build/lib/Joystick";
import { StateCreator } from "zustand";
import { Action } from "../Action";
import { ACTION_TRIGGERS } from "../ActionTriggers";
import { useStore } from "./Store";

export const createActionSlice: StateCreator<
  ActionSlice,
  [["zustand/subscribeWithSelector", never]],
  []
> = (set, get) => ({
  actions: new Map(),
  addAction: (action: Action) => {
    set({
      actions: get().actions.set(action.target, [
        ...(get().getActions(action.target) || []),
        action,
      ]),
    });
  },
  getActions: (key: string) => get().actions.get(key),
  triggerAction: (
    trigger: ACTION_TRIGGERS | any,
    targetName: string,
    targetNodeName?,
    event?
  ) => {
    const selectedActions = get()
      .actions.get(targetName)
      ?.filter(
        (action) =>
          action.targetNode === undefined && action.trigger === trigger
      );
    if (targetNodeName) {
      const selectedSubActions = get()
        .actions.get(targetName)
        ?.filter(
          (action) =>
            action.targetNode === targetNodeName && action.trigger === trigger
        );
      selectedActions?.push(...(selectedSubActions || []));
    }
    const targetObject = useStore.getState().assets.get(targetName);
    selectedActions &&
      selectedActions.forEach((action) => {
        // Some actions we would like to run a bit delayed
        if (action.delay) {
          setTimeout(() => {
            action.cb(targetObject as any, event);
          }, action.delay);
        } else {
          action.cb(targetObject as any, event);
        }
      });
  },
});

export interface ActionSlice {
  actions: Map<string, Action[]>;
  addAction: (action: Action) => void;
  getActions: (key: string) => Action[] | undefined;
  triggerAction: (
    trigger: ACTION_TRIGGERS | any,
    targetName: string,
    targetNodeName?: string,
    event?: IJoystickUpdateEvent | Event | any
  ) => void;
}
